<template>
  <!-- Import de 20 polices Google Fonts -->
  <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&family=Open+Sans:wght@300;400;600;700;800&family=Montserrat:wght@300;400;500;600;700;800;900&family=Lato:wght@300;400;700;900&family=Poppins:wght@300;400;500;600;700;800;900&family=Raleway:wght@300;400;500;600;700;800;900&family=Ubuntu:wght@300;400;500;700&family=Playfair+Display:wght@400;500;600;700;800;900&family=Merriweather:wght@300;400;700;900&family=Oswald:wght@300;400;500;600;700&family=Source+Sans+Pro:wght@300;400;600;700;900&family=Nunito:wght@300;400;600;700;800;900&family=PT+Sans:wght@400;700&family=Quicksand:wght@300;400;500;600;700&family=Bebas+Neue&family=Inter:wght@300;400;500;600;700;800;900&family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Space+Grotesk:wght@300;400;500;600;700&family=DM+Sans:wght@400;500;700&family=Work+Sans:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet">

  <div class="screen-wrapper relative w-screen h-screen overflow-hidden bg-black flex items-center justify-center">
    <div class="screen-container text-white overflow-hidden font-sans select-none" :style="getScreenContainerStyle()">


    <!-- Token Configuration Modal -->
    <div v-if="!tokenProvided" class="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/90 backdrop-blur-xl">
      <div class="bg-slate-900 p-10 rounded-[3rem] border border-slate-700 shadow-2xl max-w-md w-full text-center">
        <div class="w-20 h-20 bg-blue-600 rounded-3xl flex items-center justify-center mx-auto mb-6 shadow-lg shadow-blue-500/20">
          <svg class="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
        </div>
        <h2 class="text-2xl font-black mb-2 uppercase tracking-tight">Configuration Écran</h2>
        <p class="text-slate-400 text-sm mb-8 font-medium">Veuillez saisir le token de couplage</p>
        <input v-model="inputToken" type="password" placeholder="Token..."
               class="w-full bg-slate-800 border-2 border-slate-700 rounded-2xl px-6 py-4 mb-4 focus:border-blue-500 outline-none transition-all text-center font-mono tracking-widest text-xl">
        <button @click="saveToken" class="w-full bg-blue-600 hover:bg-blue-500 text-white font-black py-4 rounded-2xl transition-all shadow-lg shadow-blue-600/20 active:scale-95">
          ACTIVER L'ÉCRAN
        </button>
      </div>
    </div>

<!-- ✅ BANNER COMMENTÉE - REMPLACÉE PAR LE CLIGNOTEMENT DE LA DERNIÈRE LIGNE APPELÉE -->
<!--
<transition name="banner-slide">
  <div
    v-if="callingTicket && tokenProvided"
    class="banner-slide-container"
    role="alert"
  >
    <div
      class="banner-slide-content"
      :style="getBannerContentStyle()"
    >

      <div class="banner-left-section">
        <div
          class="banner-icon-container"
          :style="getBannerIconContainerStyle()"
        >
          <PharmacyIcon v-if="callingTicket?.queueId?.icon"
            :name="callingTicket.queueId?.icon || ' '"
            :size="90"
            :color="getBannerIconColor()"
          />
        </div>

        <div class="banner-ticket-info">
          <span
            class="banner-queue-name"
            :style="getBannerQueueNameStyle()"
          >
             {{ callingTicket.queueId?.name || 'Patient' }}
          </span>
          <h1
            class="banner-ticket-number"
            :style="getBannerTicketNumberStyle()"
          >
            {{ callingTicket.number }}
          </h1>
        </div>
      </div>

      <div class="banner-right-section">
        <div
          class="banner-counter-badge"
          :style="getBannerCounterBadgeStyle()"
        >
          <span
            class="banner-counter-name"
            :style="getBannerCounterTextStyle()"
          >
            {{ callingTicket.counterName || 'Guichet' }}
          </span>
        </div>

      </div>


    </div>
  </div>
</transition>
-->



    <template v-if="screenConfig">


      <!-- Logo -->
      <div v-if="screenConfig.branding.logo.show && screenConfig.branding.logo.url"
           :style="getLogoPositionStyle()">
        <img :src="screenConfig.branding.logo.url" :style="{ width: screenConfig.branding.logo.size + 'px', height: 'auto' }" />
      </div>

      <!-- Dynamic Zones Layout -->
      <div :class="screenConfig.layout.type === 'custom' ? '' : 'flex ' + getLayoutClass()"
           :style="getMainLayoutStyle()">

        <div v-for="zone in screenConfig.zones" :key="zone.id"
             class="relative overflow-hidden transition-all"
             :style="getZoneStyle(zone)">

          <!-- Queue Display Content -->
          <div v-if="zone.content.type === 'queue_display'" class="w-full h-full flex flex-col" :style="getQueueDisplayContainerStyle(zone)">
            <div class="flex-1 overflow-auto">
              <!-- Called Tickets (if filter allows) -->
              <div v-if="zone.content.ticketFilter === 'CALLED' || zone.content.ticketFilter === 'BOTH'">
                <h2 v-if="zone.name && zone.name.trim() !== ''" :style="getTitleStyle(zone)" style="margin-bottom: 16px; text-transform: uppercase; letter-spacing: 0.05em; opacity: 0.7;">
                  {{ zone.name }}
                </h2>



                <div style="display: flex; flex-direction: column; gap: 12px;">
                  <div v-for="ticket in getFilteredTickets(zone, 'CALLED').slice(0, zone.content.maxTickets || 15)" :key="ticket._id"
                       :class="{
                         'blinking-ticket-normal': blinkingTicketId === ticket._id && blinkingTicketType === 'normal',
                         'blinking-ticket-recall': blinkingTicketId === ticket._id && blinkingTicketType === 'recall'
                       }"
                       style="display: flex; justify-content: space-between; align-items: center; padding: 16px; border-radius: 16px; box-sizing: border-box;"
                       :style="{ backgroundColor: zone.style.backgroundColor + '15' }">
                    <div style="display: flex; flex-direction: column;">
                      <div v-if="zone.content.ticketDisplayInfo?.showNumber !== false" :style="getTicketItemNumberStyle(zone)" style="display: flex; align-items: center; gap: 8px;">
                       <PharmacyIcon v-if="ticket.queueId?.icon"
                          :name="ticket.queueId?.icon || ' '"
                          :size="20"
                          :color="zone.textStyle?.color || '#FFFFFF'"
                        />
                        {{ ticket.number }}
                      </div>
                      <div v-if="zone.content.ticketDisplayInfo?.showQueueName !== false"
                           :style="getTicketItemLabelStyle(zone)">
                        {{ ticket.queueId?.name || 'Service' }}
                      </div>
                    </div>
                    <div v-if="zone.content.ticketDisplayInfo?.showCounterName !== false" :style="getCounterBadgeStyle(zone)">
                      {{ ticket.counterName || 'Caisse' }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Waiting Tickets (if filter allows) -->
              <div v-if="zone.content.ticketFilter === 'WAITING' || zone.content.ticketFilter === 'BOTH'" :style="{ marginTop: zone.content.ticketFilter === 'BOTH' ? '32px' : '0' }">
                <h2 v-if="zone.name && zone.name.trim() !== ''" :style="getTitleStyle(zone)" style="margin-bottom: 16px; text-transform: uppercase; letter-spacing: 0.05em; opacity: 0.7;">
                  {{ zone.name }}
                </h2>

                <div :style="getWaitingGridStyle(zone)">
                  <div v-for="ticket in getFilteredTickets(zone, 'WAITING').slice(0, zone.content.maxTickets || 10)" :key="ticket._id"
                       :style="getWaitingItemStyle(zone)">
                    <div v-if="zone.content.ticketDisplayInfo?.showNumber !== false" :style="getWaitingTicketNumberStyle(zone)" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                     <PharmacyIcon v-if="ticket.queueId?.icon"
                        :name="ticket.queueId?.icon || ' '"
                        :size="16"
                        :color="zone.content.waitingTicketStyle?.color || zone.textStyle?.color || '#FFFFFF'"
                      />
                      {{ ticket.number }}
                    </div>
                    <div v-if="zone.content.ticketDisplayInfo?.showQueueName !== false"
                         :style="getWaitingTicketLabelStyle(zone)">
                      {{ ticket.queueId?.name || 'Service' }}
                    </div>
                    <div v-if="zone.content.ticketDisplayInfo?.showWaitTime === true" :style="{ fontSize: '10px', fontWeight: '700', opacity: 0.6, marginTop: '4px', color: zone.content.waitingTicketStyle?.color || zone.textStyle?.color }">
                      {{ getWaitTime(ticket.createdAt) }} min
                    </div>
                  </div>
                </div>
              </div>

              <!-- History Tickets -->
              <div v-if="zone.content.ticketFilter === 'HISTORY'">
                <h2 v-if="zone.name && zone.name.trim() !== ''" :style="getTitleStyle(zone)" style="margin-bottom: 16px; text-transform: uppercase; letter-spacing: 0.05em; opacity: 0.7;">
                  {{ zone.name }}
                </h2>

                <div :style="getHistoryGridStyle(zone)">
                  <div v-for="ticket in getHistoryTickets(zone).slice(0, zone.content.maxTickets || 12)" :key="ticket._id"
                       :style="getHistoryItemStyle(zone)">
                    <div v-if="zone.content.ticketDisplayInfo?.showNumber !== false" :style="getHistoryTicketNumberStyle(zone)" style="display: flex; align-items: center; justify-content: center; gap: 8px;">
                     <PharmacyIcon v-if="ticket.queueId?.icon"
                        :name="ticket.queueId?.icon || ' '"
                        :size="14"
                        :color="zone.content.historyTicketStyle?.color || zone.textStyle?.color || '#64748B'"
                      />
                      {{ ticket.number }}
                    </div>
                    <div v-if="zone.content.ticketDisplayInfo?.showQueueName !== false"
                         :style="getHistoryTicketLabelStyle(zone)">
                      {{ ticket.queueId?.name || 'Service' }}
                    </div>
                    <!-- ✅ AJOUTÉ : Affichage du nom de la caisse dans l'historique -->
                    <div v-if="zone.content.ticketDisplayInfo?.showCounterName !== false && ticket.counterName"
                         :style="getHistoryCounterNameStyle(zone)">
                      {{ ticket.counterName }}
                    </div>
                    <div v-if="zone.content.ticketDisplayInfo?.showWaitTime === true" :style="{ fontSize: '10px', fontWeight: '700', opacity: 0.5, marginTop: '4px', color: zone.content.historyTicketStyle?.color || zone.textStyle?.color }">
                      {{ ticket.status === 'DONE' ? 'Terminé' : ticket.status === 'ARCHIVED' ? 'Archivé' : 'Passé' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Video Content -->
          <div v-else-if="zone.content.type === 'video'" class="w-full h-full">
            <video v-if="zone.content.videoUrl"
                   :src="zone.content.videoUrl"
                   :autoplay="zone.content.autoplay"
                   :loop="zone.content.loop"
                   class="w-full h-full object-cover">
            </video>
          </div>

          <!-- Image Content -->
          <div v-else-if="zone.content.type === 'image'" class="w-full h-full">
            <img v-if="zone.content.imageUrl"
                 :src="zone.content.imageUrl"
                 class="w-full h-full"
                 :style="{ objectFit: zone.content.imageFit || 'cover' }" />
          </div>

          <!-- Text Content -->
          <div v-else-if="zone.content.type === 'text'" class="w-full h-full flex items-center justify-center p-8"
               :style="{
                 fontFamily: zone.textStyle.fontFamily,
                 fontSize: zone.textStyle.fontSize + 'px',
                 color: zone.textStyle.color,
                 textAlign: zone.textStyle.textAlign,
                 ...getTextShadowStyle(zone)
               }">
            {{ zone.content.text }}
          </div>

          <!-- Clock Content -->
          <div v-else-if="zone.content.type === 'clock'" style="width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <div :style="getClockTimeStyle(zone)">{{ currentTime }}</div>
            <div v-if="zone.content.showDate" :style="getClockDateStyle(zone)">{{ currentDate }}</div>
          </div>

          <!-- Weather Content -->
          <div v-else-if="zone.content.type === 'weather'" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">
            <div style="text-align: center;">
              <div style="margin-bottom: 16px;">
                <UIIcon name="sun" :size="128" :color="zone.textStyle?.color || '#FDB813'" />
              </div>
              <div :style="getWeatherTempStyle(zone)">24°C</div>
              <div :style="getWeatherLocationStyle(zone)">{{ zone.content.location || 'Paris' }}</div>
            </div>
          </div>

          <!-- Custom HTML Content -->
          <div v-else-if="zone.content.type === 'custom_html'" class="w-full h-full" v-html="zone.content.html"></div>
        </div>
      </div>
    </template>

    <!-- Audio for notifications -->
    <audio
      ref="bellSound"
      preload="auto"
      crossorigin="anonymous"
      volume="0.8"
    >
      <source src="https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3" type="audio/mpeg">
      <!-- Fallback source -->
      <source src="https://cdn.freesound.org/previews/320/320655_5260872-lq.mp3" type="audio/mpeg">
    </audio>

    <!-- Bouton pour activer le son manuellement (pour Xibo) -->
    <!-- Afficher seulement si l'audio est activé dans la config ET que le navigateur n'a pas débloqué l'audio -->
    <button
      v-if="tokenProvided && screenConfig?.audio?.enabled && !audioEnabled"
      @click="forceUnlockAudio"
      class="fixed bottom-4 right-4 z-50 bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-xl shadow-lg flex items-center gap-2 font-bold transition-all active:scale-95 animate-pulse"
      style="animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;"
    >
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
      </svg>
      🔊 Activer le son
    </button>

      <!-- Indicateur visuel quand l'audio est désactivé par l'admin -->
      <div
        v-if="tokenProvided && screenConfig && screenConfig.audio && !screenConfig.audio.enabled"
        class="fixed bottom-4 right-4 z-50 bg-gray-700 text-white px-4 py-2 rounded-xl shadow-lg flex items-center gap-2 text-sm font-medium opacity-60"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" />
          <line x1="1" y1="1" x2="23" y2="23" stroke-width="2" />
        </svg>
        Son désactivé
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref,  onMounted, onUnmounted } from 'vue';
import { io } from 'socket.io-client';
import PharmacyIcon from '@/components/PharmacyIcons.vue';
import UIIcon from '@/components/UIIcons.vue';


const socket = ref(null);
const screenConfig = ref(null);
const tickets = ref([]);
const callingTicket = ref(null);
const inputToken = ref('');
const tokenProvided = ref(false);
const audioEnabled = ref(false); // ✅ CORRIGÉ: false par défaut, sera activé par l'utilisateur
const speechEnabled = ref(false); // ✅ État du déblocage de la synthèse vocale
const bellSound = ref(null);
const isRecall = ref(false);
const blinkingTicketId = ref(null); // ✅ ID du ticket qui doit clignoter
const blinkingTicketType = ref(null); // ✅ Type de clignotement : 'normal' ou 'recall'

const currentTime = ref(new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }));
const currentDate = ref(new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }));
const windowSize = ref({ width: window.innerWidth, height: window.innerHeight });

let clockInterval = null;
let refreshInterval = null;

// Update clock every second
clockInterval = setInterval(() => {
  currentTime.value = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  currentDate.value = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
}, 1000);

const getGlobalBackgroundStyle = () => {
  if (!screenConfig.value) return { backgroundColor: '#0f172a' };

  const branding = screenConfig.value.branding;

  if (branding.backgroundType === 'gradient' && branding.gradient) {
    return {
      background: `linear-gradient(${branding.gradient.direction}, ${branding.gradient.color1}, ${branding.gradient.color2})`
    };
  } else if (branding.backgroundType === 'image' && branding.backgroundImage) {
    return {
      backgroundImage: `url(${branding.backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    };
  }

  return {
    backgroundColor: branding.backgroundColor
  };
};

const getScreenContainerStyle = () => {
  const baseStyle = getGlobalBackgroundStyle();

  if (!screenConfig.value) {
    return {
      ...baseStyle,
      width: '100vw',
      height: '100vh',
      position: 'absolute',
      left: '0',
      top: '0'
    };
  }

  const resolution = screenConfig.value.targetResolution || { width: 1920, height: 1080 };
  const targetWidth = Math.max(1, Number(resolution.width) || 1920);
  const targetHeight = Math.max(1, Number(resolution.height) || 1080);

  // Utiliser windowSize.value pour la réactivité
  const viewportWidth = windowSize.value.width;
  const viewportHeight = windowSize.value.height;

  // ✅ Rendu dans le repère de conception (ex: 1920×1080) puis réduction/agrandissement
  // global. Ainsi l'aperçu de l'éditeur et la TV ont exactement les mêmes proportions,
  // quelle que soit la résolution réelle de l'écran.
  const scale = Math.min(
    viewportWidth / targetWidth,
    viewportHeight / targetHeight
  );

  return {
    ...baseStyle,
    width: `${targetWidth}px`,
    height: `${targetHeight}px`,
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: `translate(-50%, -50%) scale(${Math.max(0.05, scale)})`,
    transformOrigin: 'center center',
    flexShrink: 0
  };
};

const getMainLayoutStyle = () => {
  if (!screenConfig.value) return {};

  return {
    width: '100%',
    height: '100%',
    padding: `${screenConfig.value.layout?.padding ?? 24}px`,
    gap: `${screenConfig.value.layout?.gap ?? 20}px`,
    fontFamily: screenConfig.value.branding?.fonts?.primary || 'sans-serif',
    boxSizing: 'border-box',
    overflow: 'hidden'
  };
};

const getLogoPositionStyle = () => {
  if (!screenConfig.value) return {};

  const position = screenConfig.value.branding.logo.position || 'top-left';

  // Style de base (position absolute + z-index + padding)
  const baseStyle = {
    position: 'absolute',
    zIndex: '50',
    padding: '24px'
  };

  // Styles selon la position
  const positionStyles = {
    'top-left': {
      top: '0',
      left: '0'
    },
    'top-center': {
      top: '0',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    'top-right': {
      top: '0',
      right: '0'
    },
    'bottom-left': {
      bottom: '0',
      left: '0'
    },
    'bottom-center': {
      bottom: '0',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    'bottom-right': {
      bottom: '0',
      right: '0'
    }
  };

  return {
    ...baseStyle,
    ...(positionStyles[position] || positionStyles['top-left'])
  };
};

const getLayoutClass = () => {
  if (!screenConfig.value?.layout) return 'flex-col';

  const layouts = {
    'single': 'flex-col',
    'split_horizontal': 'flex-row items-stretch',
    'split_vertical': 'flex-col items-stretch',
    'grid_2x2': 'grid grid-cols-2 grid-rows-2',
    'custom': '' // Pas de classe flex en mode custom
  };

  return layouts[screenConfig.value.layout.type] || 'flex-col';
};

// Fonctions helper pour styles compatibles navigateurs anciens
const getQueueDisplayContainerStyle = (zone) => {
  return {
    padding: `${zone.style?.padding ?? 20}px`,
    boxSizing: 'border-box'
  };
};

const getTextShadowStyle = (zone) => {
  if (!zone.style?.textShadow?.enabled) return {};

  const ts = zone.style.textShadow;
  const color = ts.color || '#000000';
  const alpha = ts.opacity ?? 0.5;
  const r = parseInt(color.slice(1,3), 16);
  const g = parseInt(color.slice(3,5), 16);
  const b = parseInt(color.slice(5,7), 16);
  const shadowValue = `${ts.offsetX}px ${ts.offsetY}px ${ts.blur}px rgba(${r},${g},${b},${alpha})`;

  return {
    textShadow: shadowValue,
    WebkitTextShadow: shadowValue,
    MozTextShadow: shadowValue
  };
};

const getTitleStyle = (zone) => {
  const baseFontSize = zone.textStyle?.fontSize || 24;
  return {
    fontSize: `${baseFontSize * 0.8}px`,
    fontWeight: '700',
    color: zone.textStyle?.color || '#FFFFFF',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};



const getTicketItemNumberStyle = (zone) => {
  const baseFontSize = zone.content.calledTicketStyle?.fontSize || zone.textStyle?.fontSize || 32;
  const color = zone.content.calledTicketStyle?.color || zone.textStyle?.color || '#FFFFFF';
  const fontFamily = zone.content.calledTicketStyle?.fontFamily || zone.textStyle?.fontFamily || 'sans-serif';
  return {
    fontSize: `${baseFontSize}px`,
    fontWeight: '900',
    color: color,
    fontFamily: fontFamily,
    ...getTextShadowStyle(zone)
  };
};

const getTicketItemLabelStyle = (zone) => {
  return {
    fontSize: '14px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    opacity: '0.6',
    color: zone.textStyle?.color || '#FFFFFF',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getCounterBadgeStyle = (zone) => {
  // ✅ Utiliser le counterStyle personnalisé de la zone
  const counterStyle = zone?.content?.counterStyle || {};

  console.log('[Badge] 🎨 Counter style for zone:', counterStyle);

  return {
    padding: `${counterStyle.padding || 12}px ${counterStyle.padding ? counterStyle.padding * 2 : 24}px`,
    borderRadius: `${counterStyle.borderRadius || 12}px`,
    fontSize: `${counterStyle.fontSize || 20}px`,
    fontWeight: counterStyle.fontWeight || '900',
    backgroundColor: counterStyle.backgroundColor || 'transparent',
    color: counterStyle.color || '#FFFFFF',
    fontFamily: counterStyle.fontFamily || zone?.textStyle?.fontFamily || 'sans-serif',
    borderWidth: `${counterStyle.borderWidth || 2}px`,
    borderStyle: 'solid',
    borderColor: counterStyle.borderColor || '#1e3a8a',
    ...getTextShadowStyle(zone)
  };
};

const getWaitingTicketNumberStyle = (zone) => {
  const wStyle = zone.content?.waitingTicketStyle || {};
  return {
    fontSize: `${wStyle.fontSize || 24}px`,
    fontWeight: '900',
    marginBottom: '4px',
    color: wStyle.color || zone.textStyle?.color || '#FFFFFF',
    fontFamily: wStyle.fontFamily || zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getWaitingTicketLabelStyle = (zone) => {
  const wStyle = zone.content?.waitingTicketStyle || {};
  return {
    fontSize: '12px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    opacity: '0.6',
    color: wStyle.color || zone.textStyle?.color || '#FFFFFF',
    fontFamily: wStyle.fontFamily || zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getWaitingGridStyle = (zone) => {
  const cols = zone.content?.gridColumns || 2;
  return {
    display: ['-ms-grid', 'grid'],
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap: '16px',
    msGridColumns: Array(cols).fill('1fr').join(' 16px '),
  };
};

const getWaitingItemStyle = (zone) => {
  const wStyle = zone.content?.waitingTicketStyle || {};
  return {
    padding: `${wStyle.padding || 16}px`,
    borderRadius: `${wStyle.borderRadius || 16}px`,
    boxSizing: 'border-box',
    backgroundColor: wStyle.backgroundColor || (zone.style?.backgroundColor || '#FFFFFF') + '15',
    textAlign: 'center'
  };
};

// Styles pour l'historique des tickets
const getHistoryTicketNumberStyle = (zone) => {
  const hStyle = zone.content?.historyTicketStyle || zone.content?.waitingTicketStyle || {};
  return {
    fontSize: `${hStyle.fontSize || 20}px`,
    fontWeight: '900',
    marginBottom: '4px',
    color: hStyle.color || zone.textStyle?.color || '#64748B',
    fontFamily: hStyle.fontFamily || zone.textStyle?.fontFamily || 'sans-serif',
    opacity: hStyle.opacity || 0.7,
    ...getTextShadowStyle(zone)
  };
};

const getHistoryTicketLabelStyle = (zone) => {
  const hStyle = zone.content?.historyTicketStyle || zone.content?.waitingTicketStyle || {};
  return {
    fontSize: '11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    opacity: '0.5',
    color: hStyle.color || zone.textStyle?.color || '#64748B',
    fontFamily: hStyle.fontFamily || zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

// ✅ AJOUTÉ : Style pour le nom de la caisse dans l'historique
const getHistoryCounterNameStyle = (zone) => {
  const hStyle = zone.content?.historyTicketStyle || zone.content?.waitingTicketStyle || {};
  return {
    fontSize: '12px',
    fontWeight: '800',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    marginTop: '6px',
    padding: '4px 10px',
    borderRadius: '8px',
    backgroundColor: screenConfig.value?.branding?.colors?.primary || '#3B82F6',
    color: '#FFFFFF',
    opacity: '0.9',
    display: 'inline-block',
    fontFamily: hStyle.fontFamily || zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getHistoryGridStyle = (zone) => {
  const cols = zone.content?.gridColumns || 3;
  return {
    display: ['-ms-grid', 'grid'],
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gap: '12px',
    msGridColumns: Array(cols).fill('1fr').join(' 12px '),
  };
};

const getHistoryItemStyle = (zone) => {
  const hStyle = zone.content?.historyTicketStyle || zone.content?.waitingTicketStyle || {};
  return {
    padding: `${hStyle.padding || 12}px`,
    borderRadius: `${hStyle.borderRadius || 10}px`,
    boxSizing: 'border-box',
    backgroundColor: hStyle.backgroundColor || 'rgba(200, 200, 200, 0.2)',
    textAlign: 'center',
    opacity: hStyle.opacity || 0.7
  };
};

const getHistoryTickets = (zone) => {
  // Filtrer les tickets avec statut DONE, SKIPPED ou ARCHIVED
  let filtered = [...tickets.value];

  // 1. Filtre par file d'attente (si configuré)
  if (zone.content.queueIds && Array.isArray(zone.content.queueIds) && zone.content.queueIds.length > 0) {
    const allowedQueueIds = zone.content.queueIds.map(q => (q?._id || q).toString());
    filtered = filtered.filter(t => {
      const ticketQueueId = (t.queueId?._id || t.queueId)?.toString();
      return ticketQueueId && allowedQueueIds.includes(ticketQueueId);
    });
  }

  // 2. Filtre par statut DONE, SKIPPED ou ARCHIVED
  filtered = filtered.filter(t => {
    const status = t.status?.toUpperCase();
    return status === 'DONE' || status === 'SKIPPED' || status === 'ARCHIVED';
  });

  // 3. Trier par date de modification (les plus récents en premier)
  filtered.sort((a, b) => {
    const dateA = new Date(a.updatedAt || a.createdAt);
    const dateB = new Date(b.updatedAt || b.createdAt);
    return dateB - dateA;
  });

  return filtered;
};

const getClockTimeStyle = (zone) => {
  const baseFontSize = zone.textStyle?.fontSize || 32;
  return {
    fontSize: `${baseFontSize * 3}px`,
    fontWeight: '900',
    marginBottom: '16px',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    color: zone.textStyle?.color || '#FFFFFF',
    ...getTextShadowStyle(zone)
  };
};

const getClockDateStyle = (zone) => {
  const baseFontSize = zone.textStyle?.fontSize || 32;
  return {
    fontSize: `${baseFontSize * 1.2}px`,
    fontWeight: '500',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    color: zone.textStyle?.color || '#FFFFFF',
    ...getTextShadowStyle(zone)
  };
};

const getWeatherTempStyle = (zone) => {
  const baseFontSize = zone.textStyle?.fontSize || 32;
  return {
    fontSize: `${baseFontSize * 2.5}px`,
    fontWeight: '900',
    marginBottom: '8px',
    color: zone.textStyle?.color || '#FFFFFF',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getWeatherLocationStyle = (zone) => {
  const baseFontSize = zone.textStyle?.fontSize || 32;
  return {
    fontSize: `${baseFontSize * 0.8}px`,
    color: zone.textStyle?.color || '#FFFFFF',
    fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
    ...getTextShadowStyle(zone)
  };
};

const getWaitTime = (createdAt) => {
  if (!createdAt) return 0;
  const start = new Date(createdAt);
  const now = new Date();
  return Math.floor((now - start) / 60000); // Minutes
};

const getZoneStyle = (zone) => {
  if (!zone || !zone.style) return {};

  // 1. Initialisation des styles de base (Compatibilité Xibo)
  const style = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    boxSizing: 'border-box'
  };

  // 2. Gestion du Background (Couleur, Gradient ou Image)
  const bgType = zone.style.backgroundType;
  if (bgType === 'color') {
    style.backgroundColor = zone.style.backgroundColor || 'transparent';
  } else if (bgType === 'gradient' && zone.style.gradient) {
    const g = zone.style.gradient;
    style.backgroundColor = g.color1 || '#3B82F6';
    style.background = `linear-gradient(${g.direction || 'to right'}, ${g.color1}, ${g.color2})`;
  } else if (bgType === 'image' && zone.style.backgroundImage) {
    style.backgroundImage = `url(${zone.style.backgroundImage})`;
    style.backgroundSize = 'cover';
    style.backgroundPosition = 'center';
  }

  // === PADDING (avec fallback) ===
  const pt = zone.style.paddingTop ?? zone.style.padding ?? 20;
  const pr = zone.style.paddingRight ?? zone.style.padding ?? 20;
  const pb = zone.style.paddingBottom ?? zone.style.padding ?? 20;
  const pl = zone.style.paddingLeft ?? zone.style.padding ?? 20;
  style.padding = `${pt}px ${pr}px ${pb}px ${pl}px`;

  // === MARGIN ===
  const mt = zone.style.marginTop ?? zone.style.margin ?? 0;
  const mr = zone.style.marginRight ?? zone.style.margin ?? 0;
  const mb = zone.style.marginBottom ?? zone.style.margin ?? 0;
  const ml = zone.style.marginLeft ?? zone.style.margin ?? 0;
  style.margin = `${mt}px ${mr}px ${mb}px ${ml}px`;

  // === BORDER RADIUS (avec fallback + vendor prefixes) ===
  const rtl = zone.style.borderRadiusTopLeft ?? zone.style.borderRadius ?? 0;
  const rtr = zone.style.borderRadiusTopRight ?? zone.style.borderRadius ?? 0;
  const rbr = zone.style.borderRadiusBottomRight ?? zone.style.borderRadius ?? 0;
  const rbl = zone.style.borderRadiusBottomLeft ?? zone.style.borderRadius ?? 0;
  const borderRadiusValue = `${rtl}px ${rtr}px ${rbr}px ${rbl}px`;
  style.borderRadius = borderRadiusValue;
  style.WebkitBorderRadius = borderRadiusValue;
  style.MozBorderRadius = borderRadiusValue;

  // === BORDER ===
  if (zone.style.borderWidth && zone.style.borderWidth > 0) {
    style.border = `${zone.style.borderWidth}px ${zone.style.borderStyle || 'solid'} ${zone.style.borderColor || '#000'}`;
  }

  // === BOX SHADOW (avec vendor prefixes) ===
  if (zone.style.boxShadow?.enabled) {
    const bs = zone.style.boxShadow;
    const color = bs.color || '#000000';
    const alpha = bs.opacity ?? 0.1;
    const r = parseInt(color.slice(1,3), 16);
    const g = parseInt(color.slice(3,5), 16);
    const b = parseInt(color.slice(5,7), 16);
    const shadowValue = `${bs.offsetX}px ${bs.offsetY}px ${bs.blur}px ${bs.spread}px rgba(${r},${g},${b},${alpha})`;
    style.boxShadow = shadowValue;
    style.WebkitBoxShadow = shadowValue;
    style.MozBoxShadow = shadowValue;
  }

  // === OPACITY (avec fallback IE8) ===
  if (zone.style.opacity !== undefined && zone.style.opacity !== 1) {
    style.opacity = zone.style.opacity;
    style.filter = `alpha(opacity=${Math.round(zone.style.opacity * 100)})`;
  }

  // === FILTERS (avec vendor prefixes) ===
  const filters = zone.style.filters;
  if (filters) {
    const filterArr = [];
    if (filters.blur > 0) filterArr.push(`blur(${filters.blur}px)`);
    if (filters.brightness !== 100) filterArr.push(`brightness(${filters.brightness}%)`);
    if (filters.contrast !== 100) filterArr.push(`contrast(${filters.contrast}%)`);
    if (filters.saturate !== 100) filterArr.push(`saturate(${filters.saturate}%)`);
    if (filters.hueRotate !== 0) filterArr.push(`hue-rotate(${filters.hueRotate}deg)`);
    if (filterArr.length > 0) {
      const filterValue = filterArr.join(' ');
      style.filter = filterValue;
      style.WebkitFilter = filterValue;
    }
  }

  // === TRANSFORM (avec vendor prefixes) ===
  const transform = zone.style.transform;
  if (transform) {
    const transformArr = [];
    if (transform.rotate !== 0) transformArr.push(`rotate(${transform.rotate}deg)`);
    if (transform.scale !== 1) transformArr.push(`scale(${transform.scale})`);
    if (transformArr.length > 0) {
      const transformValue = transformArr.join(' ');
      style.transform = transformValue;
      style.WebkitTransform = transformValue;
      style.MozTransform = transformValue;
      style.msTransform = transformValue;
    }
  }

  // 3. Logique de positionnement selon le Layout
  const layoutType = screenConfig.value?.layout?.type || 'single';

  if (layoutType === 'custom') {
    style.position = 'absolute';
    style.left = `${zone.position?.x || 0}%`;
    style.top = `${zone.position?.y || 0}%`;
    style.width = `${zone.position?.width || 0}%`;
    style.height = `${zone.position?.height || 0}%`;
    style.zIndex = zone.position?.z || 10;
  } else {
    style.position = 'relative';
    style.height = '100%';

    if (layoutType === 'split_horizontal' || layoutType === 'single') {
      style.flex = '1 1 0%';
      style.minWidth = '0';
    } else if (layoutType === 'split_vertical') {
      style.flex = '1 1 0%';
      style.minHeight = '0';
    }
  }

  return style;
};

const getFilteredTickets = (zone, status) => {
  // On travaille sur une copie pour éviter toute mutation accidentelle
  let filtered = [...tickets.value];

  // Groupement des logs pour une lecture propre dans la console
  console.group(`[Filter Analysis] Zone: ${zone.name || 'Sans Nom'} (Cible: ${status})`);
  console.log(`📊 Tickets reçus du serveur: ${filtered.length}`);

  // 1. FILTRE PAR FILE D'ATTENTE (QUEUE)
  if (zone.content.queueIds && Array.isArray(zone.content.queueIds) && zone.content.queueIds.length > 0) {
    const allowedQueueIds = zone.content.queueIds.map(q => (q?._id || q).toString());
    const beforeQueue = filtered.length;

    filtered = filtered.filter(t => {
      // Extraction sécurisée de l'ID de la file du ticket
      const ticketQueueId = (t.queueId?._id || t.queueId)?.toString();

      if (!ticketQueueId) {
        console.warn(`  ⚠️ Ticket ${t.number} n'a pas de queueId valide !`, t);
        return false;
      }

      const matches = allowedQueueIds.includes(ticketQueueId);

      if (!matches) {
        console.log(`  ❌ Ticket ${t.number} REJETÉ : File "${t.queueId?.name || ticketQueueId}" non autorisée dans cette zone.`);
      } else {
        console.log(`  ✅ Ticket ${t.number} GARDÉ (File: ${t.queueId?.name || 'OK'})`);
      }
      return matches;
    });

    console.log(`📉 Après filtre file: ${beforeQueue} → ${filtered.length}`);
  } else {
    console.log(`✅ Aucune restriction de file pour cette zone.`);
  }

  // 2. FILTRE PAR STATUT (WAITING, CALLED, etc.)
  if (status) {
    const beforeStatus = filtered.length;
    filtered = filtered.filter(t => {
      const tStatus = t.status?.toUpperCase();
      const targetStatus = status.toUpperCase();

      // ✅ Si on demande les tickets CALLED, inclure aussi les tickets DONE
      // Ils resteront visibles et sortiront uniquement par le système FIFO
      if (targetStatus === 'CALLED') {
        const matches = tStatus === 'CALLED' || tStatus === 'DONE';
        if (!matches) {
          console.log(`  ❌ Ticket ${t.number} REJETÉ : Statut "${tStatus}" (ni CALLED ni DONE)`);
        }
        return matches;
      }

      // Pour les autres statuts (WAITING, HISTORY, etc.), filtre strict
      const matches = tStatus === targetStatus;
      if (!matches) {
        console.log(`  ❌ Ticket ${t.number} REJETÉ : Statut "${tStatus}" ne correspond pas à "${targetStatus}"`);
      }
      return matches;
    });
    console.log(`📉 Après filtre statut: ${beforeStatus} → ${filtered.length}`);
  }

  // 3. LIMITATION ET TRI POUR LES TICKETS APPELÉS (CALLED + DONE)
  // Afficher les X derniers tickets appelés (le plus récent en haut)
  if (status && status.toUpperCase() === 'CALLED') {
    const maxCalledTickets = zone.content.maxCalledTickets || 5;
    console.log(`📋 Limitation des tickets appelés (max: ${maxCalledTickets})...`);

    // Trier par date d'appel décroissante (plus récent en premier)
    // ✅ On utilise uniquement calledAt pour que les tickets DONE gardent leur position
    // et descendent naturellement quand de nouveaux tickets sont appelés
    filtered.sort((a, b) => {
      const dateA = new Date(a.calledAt || a.updatedAt || a.createdAt);
      const dateB = new Date(b.calledAt || b.updatedAt || b.createdAt);
      return dateB - dateA; // Plus récent d'abord
    });

    console.log(`  📊 ${filtered.length} ticket(s) au total (CALLED + DONE)`);

    // Garder seulement les X plus récents
    const beforeLimit = filtered.length;
    filtered = filtered.slice(0, maxCalledTickets);

    if (beforeLimit > maxCalledTickets) {
      console.log(`  ✂️ ${beforeLimit - maxCalledTickets} ticket(s) au-delà de la limite (sortent de l'affichage FIFO)`);
    }

    console.log(`📊 Total après limitation: ${filtered.length} tickets (plus récent en haut)`);
  }

  console.log(`🏁 TOTAL AFFICHÉ POUR CETTE ZONE: ${filtered.length}`);
  console.groupEnd();

  return filtered;
};
const checkToken = () => {
  console.log("[Screen] 🔍 Vérification du token...");
  
  // 1. Chercher dans l'URL (?token=...)
  const urlParams = new URLSearchParams(window.location.search);
  const urlToken = urlParams.get("token");
  
  // 2. Chercher dans le localStorage
  const localToken = localStorage.getItem("deviceToken");

  // Priorité au token de l'URL (permet de changer de config facilement)
  const tokenToUse = urlToken || localToken;

  if (tokenToUse) {
    console.log("[Screen] ✅ Token identifié:", tokenToUse);
    
    // Si le token vient de l'URL, on le sauvegarde pour les prochaines fois
    if (urlToken) {
      localStorage.setItem("deviceToken", urlToken);
      // Optionnel : Nettoyer l'URL sans recharger la page
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }

    tokenProvided.value = true;
    initSocket(tokenToUse);
  } else {
    console.warn("[Screen] ⚠️ Aucun token trouvé. En attente de saisie manuelle.");
  }
};
const saveToken = async () => {
  if (inputToken.value.trim()) {
    localStorage.setItem("deviceToken", inputToken.value.trim());
    tokenProvided.value = true;

    // --- LE FIX ICI ---
    // Le clic utilisateur sur ce bouton autorise désormais l'audio pour toute la session
    try {
      // 1. Débloquer l'audio
      if (bellSound.value) {
        bellSound.value.muted = true; // On commence en muet
        await bellSound.value.play();
        bellSound.value.pause();
        bellSound.value.muted = false; // On retire le mode muet pour les futurs appels
        audioEnabled.value = true;
        window.__AUDIO_UNLOCKED__ = true;
        console.log("[Audio] ✅ Déverrouillé grâce au clic utilisateur");
      }

      // 2. Débloquer la synthèse vocale avec la fonction dédiée
      await enableSpeechSynthesis();
    } catch (e) {
      console.error("[Audio] Échec de l'unlock", e);
    }

    initSocket(inputToken.value.trim());
  }
};



const enableAudio = async () => {
  console.log("[Audio] 🔓 Tentative d'unlock audio USER GESTURE");

  try {
    const audio = bellSound.value;
    if (!audio) {
      console.error("[Audio] ❌ Élément audio introuvable");
      return false;
    }

    console.log("[Audio] 📊 État actuel:", {
      paused: audio.paused,
      readyState: audio.readyState,
      networkState: audio.networkState,
      src: audio.src || audio.currentSrc
    });

    // Important : volume audible (utiliser le volume de la config si disponible)
    audio.volume = screenConfig.value?.audio?.volume ?? 0.8;
    audio.muted = false;

    // Forcer le chargement si nécessaire
    if (audio.readyState < 2) {
      console.log("[Audio] 📥 Chargement de l'audio...");
      audio.load();
      await new Promise(resolve => {
        audio.addEventListener('canplaythrough', resolve, { once: true });
        setTimeout(resolve, 2000); // Timeout de sécurité
      });
    }

    // Petit hack Chrome : jouer un tout petit bout
    console.log("[Audio] ▶️ Tentative de lecture...");
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      await playPromise;
      console.log("[Audio] ✅ Lecture démarrée avec succès");
    }

    // Laisser jouer 150ms pour que Chrome valide le gesture
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
      console.log("[Audio] ⏸️ Audio mis en pause");
    }, 150);

    audioEnabled.value = true;

    // 🔥 FLAG GLOBAL → tous les futurs play() passent
    window.__AUDIO_UNLOCKED__ = true;

    // Débloquer la synthèse vocale avec la fonction dédiée
    await enableSpeechSynthesis();

    console.log("[Audio] ✅ Audio et synthèse vocale définitivement débloqués");
    return true;
  } catch (err) {
    console.error("[Audio] ❌ Unlock échoué:", err.name, err.message);
    // Tenter quand même de définir le flag pour les prochaines tentatives
    window.__AUDIO_UNLOCKED__ = true;
    return false;
  }
};

// Fonction dédiée pour débloquer la synthèse vocale
const enableSpeechSynthesis = async () => {
  if (!('speechSynthesis' in window)) {
    console.error("[Voice] ❌ speechSynthesis n'est pas disponible");
    return false;
  }

  if (window.__SPEECH_UNLOCKED__) {
    console.log("[Voice] ℹ️ Synthèse vocale déjà débloquée");
    return true;
  }

  try {
    console.log("[Voice] 🔓 Déblocage de la synthèse vocale...");

    // Annuler toute synthèse en cours
    speechSynthesis.cancel();

    // Forcer le chargement des voix
    const voices = speechSynthesis.getVoices();
    console.log(`[Voice] 📋 ${voices.length} voix détectées`);

    // Créer et jouer un message silencieux pour débloquer
    const silentMsg = new SpeechSynthesisUtterance(' ');
    silentMsg.volume = 0.01;
    silentMsg.rate = 10;

    // Attendre la fin du message silencieux
    await new Promise((resolve) => {
      silentMsg.onend = () => {
        console.log("[Voice] ✅ Message silencieux terminé");
        resolve(true);
      };
      silentMsg.onerror = (err) => {
        console.warn("[Voice] ⚠️ Erreur message silencieux:", err);
        resolve(false); // On résout quand même
      };

      speechSynthesis.speak(silentMsg);

      // Timeout de sécurité
      setTimeout(() => {
        console.log("[Voice] ⏰ Timeout déblocage");
        resolve(true);
      }, 1000);
    });

    window.__SPEECH_UNLOCKED__ = true;
    speechEnabled.value = true;
    console.log("[Voice] ✅ Synthèse vocale débloquée");
    return true;
  } catch (err) {
    console.error("[Voice] ❌ Erreur déblocage:", err);
    // Marquer comme débloqué quand même pour éviter les blocages
    window.__SPEECH_UNLOCKED__ = true;
    speechEnabled.value = true;
    return false;
  }
};

// Fonction pour forcer le déblocage avec feedback visuel
const forceUnlockAudio = async () => {
  console.log("[Audio] 🎯 Déblocage forcé via bouton");

  try {
    // 1. Débloquer l'audio
    const audio = bellSound.value;
    if (audio) {
      audio.muted = false;
      audio.volume = screenConfig.value?.audio?.volume || 0.8;

      await audio.play();

      setTimeout(() => {
        audio.pause();
        audio.currentTime = 0;
      }, 100);
    }

    // 2. Débloquer la synthèse vocale avec la fonction dédiée
    await enableSpeechSynthesis();

    // 3. Sauvegarder l'état
    audioEnabled.value = true;
    localStorage.setItem('audio_unlocked', 'true');
    window.__AUDIO_UNLOCKED__ = true;
    window.__SPEECH_UNLOCKED__ = true;

    console.log("[Audio] ✅ Audio et synthèse vocale débloqués");
  } catch (err) {
    console.error("[Audio] Erreur d'activation:", err);
  }
};


const initSocket = (deviceToken) => {
  console.log("[Socket] 🌐 Initialisation connexion (Mode Stabilité Xibo)...");

  // Configuration optimisée pour éviter les coupures Heroku/Xibo
socket.value = io("https://api.datafuse.fr", {
  query: { token: deviceToken },
  transports: ['websocket'], // Strictement WebSocket
  upgrade: false,             // IMPORTANT : Empêche la négociation de protocole qui fait crash Xibo
  secure: true,              // Force le SSL
  rejectUnauthorized: false,  // Autorise les certificats si le player est sur une version OS ancienne
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 5000     // Laisse le temps au Player de respirer
});

  // --- GESTION DES ÉVÉNEMENTS DE CONNEXION ---

  socket.value.on("connect", () => {
    console.log("[Socket] ⚡ Connecté au serveur avec succès");

    // Tentative de déblocage audio lors de la connexion
    if (!window.__AUDIO_UNLOCKED__) {
      console.log("[Audio] 🔌 Tentative de déblocage lors de la connexion socket");
      enableAudio().catch(() => {
        console.log("[Audio] ℹ️ Déblocage impossible sans interaction (normal)");
      });
    }

    // Si après 3 secondes on n'a toujours pas la config, on la demande explicitement
    setTimeout(() => {
      if (!screenConfig.value) {
        console.log("[Config] ⏱️ Config non reçue après 3s, demande manuelle...");
        requestScreenConfig();
      }
    }, 3000);
  });

  socket.value.on("disconnect", (reason) => {
    console.warn("[Socket] 🔌 Déconnecté ! Raison:", reason);
    if (reason === "io server disconnect") {
      // Si c'est le serveur qui a coupé, on force la reconnexion manuelle
      socket.value.connect();
    }
  });

  socket.value.on("connect_error", (err) => {
    console.error("[Socket] ❌ Erreur de connexion:", err.message);
  });


  // --- RÉCEPTION DES DONNÉES INITIALES ---

socket.value.on("screen_init", (data) => {
    console.log("[Socket] 📥 Données initiales reçues", data);

    // 1. Mise à jour des tickets avec fusion intelligente
    if (data.tickets) {
      // Trouver les tickets récemment appelés localement (moins de 10 secondes)
      // ✅ IMPORTANT: Exclure les tickets DONE du cache
      const now = new Date().getTime();
      const recentlyCalledTickets = tickets.value.filter(t => {
        if (t.status === 'CALLED' && t.updatedAt) {
          const ticketTime = new Date(t.updatedAt).getTime();
          const ageInSeconds = (now - ticketTime) / 1000;
          return ageInSeconds < 10; // Tickets appelés il y a moins de 10 secondes
        }
        return false;
      });

      // Créer un map des tickets récemment appelés par numéro
      const recentCalledMap = {};
      recentlyCalledTickets.forEach(t => {
        recentCalledMap[t.number] = t;
      });

      // Fusionner: garder les tickets récemment appelés SAUF si le serveur dit qu'ils sont DONE
      const mergedTickets = data.tickets.map(serverTicket => {
        const recentTicket = recentCalledMap[serverTicket.number];

        // ✅ Si le serveur dit que le ticket est DONE, TOUJOURS utiliser la version serveur
        if (serverTicket.status === 'DONE' || serverTicket.status === 'ABSENT') {
          console.log(`[Tickets] ✅ Ticket ${serverTicket.number} : ${serverTicket.status} sur serveur, suppression locale`);
          return serverTicket;
        }

        if (recentTicket) {
          console.log(`[Tickets] 🔄 Préservation du ticket récemment appelé: ${serverTicket.number}`);
          return recentTicket; // Garder la version locale récente
        }
        return serverTicket; // Utiliser la version du serveur
      });

      // Ajouter les tickets récemment appelés qui ne sont plus dans la liste du serveur
      // ✅ MAIS ne pas ajouter les tickets DONE/ABSENT
      recentlyCalledTickets.forEach(recentTicket => {
        if (!mergedTickets.find(t => t.number === recentTicket.number)) {
          // Ne réajouter que les tickets en statut CALLED
          if (recentTicket.status === 'CALLED') {
            console.log(`[Tickets] ➕ Ajout du ticket récemment appelé absent du serveur: ${recentTicket.number}`);
            mergedTickets.push(recentTicket);
          } else {
            console.log(`[Tickets] ⏭️ Ticket ${recentTicket.number} ignoré (statut: ${recentTicket.status})`);
          }
        }
      });

      tickets.value = mergedTickets;
      console.log("[Tickets] 📊 Tickets chargés :", tickets.value.length, `(dont ${recentlyCalledTickets.length} récemment appelés préservés)`);

      // DEBUG: Vérifier la structure des tickets avec queueId.icon
      if (tickets.value.length > 0) {
        console.log("[DEBUG] Premier ticket:", {
          number: tickets.value[0].number,
          queueId: tickets.value[0].queueId,
          hasIcon: !!tickets.value[0].queueId?.icon,
          iconValue: tickets.value[0].queueId?.icon
        });
      }
    }

    // 2. Mise à jour de la config
    if (data.screenConfig) {
      console.log("[Config] 📦 Application de la nouvelle configuration...");
      
      // Enrichissement des zones
      if (data.screenConfig.zones) {
        data.screenConfig.zones.forEach(zone => {
          if (zone.content?.type === 'queue_display') {
            if (!zone.content.ticketFilter) {
              zone.content.ticketFilter = 'BOTH';
            }
            if (!zone.content.gridColumns) {
              zone.content.gridColumns = 2;
            }
            if (!zone.content.maxTickets) {
              zone.content.maxTickets = 10;
            }
            if (!zone.content.calledTicketDisplayFormat) {
              zone.content.calledTicketDisplayFormat = 'block';
            }
            if (!zone.content.maxCalledTickets) {
              zone.content.maxCalledTickets = 5;
            }
            if (!zone.content.ticketDisplayInfo) {
              zone.content.ticketDisplayInfo = {
                showNumber: true,
                showQueueName: true,
                showCounterName: true,
                showWaitTime: false
              };
            }
            if (!zone.content.waitingTicketStyle) {
              zone.content.waitingTicketStyle = {
                fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
                fontSize: 24,
                color: zone.textStyle?.color || '#FFFFFF',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: 16,
                borderRadius: 12
              };
            }
            // ✅ Initialiser counterStyle si manquant
            if (!zone.content.counterStyle) {
              zone.content.counterStyle = {
                fontFamily: zone.textStyle?.fontFamily || 'Plus Jakarta Sans',
                fontSize: 38,
                fontWeight: '700',
                color: zone.textStyle?.color || '#FFFFFF',
                backgroundColor: 'transparent',
                padding: 12,
                borderRadius: 12,
                borderWidth: 2,
                borderColor: '#1e3a8a'
              };
            }
          }
        });
      }

      // Initialiser et compléter les paramètres audio
      const defaultAudio = {
        enabled: true,
        volume: 0.8,
        callSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
        recallSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
        useVoice: true,
        voiceLang: 'fr-FR'
      };

      if (!data.screenConfig.audio) {
        data.screenConfig.audio = defaultAudio;
        console.log("[Config] 🔊 Paramètres audio initialisés par défaut");
      } else {
        // Fusionner avec les valeurs par défaut pour compléter les propriétés manquantes
        data.screenConfig.audio = {
          ...defaultAudio,
          ...data.screenConfig.audio
        };
        console.log("[Config] 🔊 Paramètres audio complétés:", {
          enabled: data.screenConfig.audio.enabled,
          useVoice: data.screenConfig.audio.useVoice,
          voiceLang: data.screenConfig.audio.voiceLang
        });
      }

      // Initialiser les paramètres d'animation si manquants
      if (!data.screenConfig.animations) {
        data.screenConfig.animations = {
          enabled: true,
          ticketTransition: 'fade',
          transitionDuration: 500
        };
        console.log("[Config] 🎬 Paramètres d'animation initialisés par défaut");
      }

      // Initialiser les paramètres de la banner si manquants
      const defaultBanner = {
        normal: {
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: 'rgba(255, 255, 255, 0.2)',
          textColor: 'rgb(15, 23, 42)',
          iconColor: '#1e3a8a',
          iconBackgroundColor: 'rgb(239, 246, 255)',
          badgeColor: 'rgb(29, 78, 216)',
          badgeBorderColor: 'rgb(29, 78, 216)'
        },
        recall: {
          backgroundColor: 'rgb(15, 23, 42)',
          borderColor: 'rgba(245, 158, 11, 0.4)',
          textColor: 'rgb(251, 191, 36)',
          iconColor: '#f59e0b',
          iconBackgroundColor: 'rgba(245, 158, 11, 0.1)',
          badgeColor: 'rgb(245, 158, 11)',
          badgeBorderColor: 'rgb(245, 158, 11)',
          recallBadgeColor: 'rgb(245, 158, 11)'
        },
        borderRadius: 32,
        borderWidth: 1,
        shadowOpacity: 0.3,
        displayDuration: {
          normal: 5,
          recall: 7
        },
        fontFamily: 'Plus Jakarta Sans',
        ticketNumberSize: 144,
        queueNameSize: 24,
        badgeSize: 56,
        instructionSize: 20,
        height: 180,
        preset: 'default'
      };

      if (!data.screenConfig.banner) {
        data.screenConfig.banner = defaultBanner;
        console.log("[Config] 📢 Paramètres de banner initialisés par défaut");
      } else {
        // Fusionner avec les valeurs par défaut pour compléter les propriétés manquantes
        console.log("[Config] 📢 Banner reçue du serveur:", JSON.stringify(data.screenConfig.banner, null, 2));

        // Compléter normal
        if (!data.screenConfig.banner.normal) {
          data.screenConfig.banner.normal = defaultBanner.normal;
        } else {
          data.screenConfig.banner.normal = {
            ...defaultBanner.normal,
            ...data.screenConfig.banner.normal
          };
        }

        // Compléter recall
        if (!data.screenConfig.banner.recall) {
          data.screenConfig.banner.recall = defaultBanner.recall;
        } else {
          data.screenConfig.banner.recall = {
            ...defaultBanner.recall,
            ...data.screenConfig.banner.recall
          };
        }

        // Compléter displayDuration
        if (!data.screenConfig.banner.displayDuration) {
          data.screenConfig.banner.displayDuration = defaultBanner.displayDuration;
        } else {
          data.screenConfig.banner.displayDuration = {
            ...defaultBanner.displayDuration,
            ...data.screenConfig.banner.displayDuration
          };
        }

        // Compléter les autres propriétés
        if (!data.screenConfig.banner.fontFamily) data.screenConfig.banner.fontFamily = defaultBanner.fontFamily;
        if (!data.screenConfig.banner.ticketNumberSize) data.screenConfig.banner.ticketNumberSize = defaultBanner.ticketNumberSize;
        if (!data.screenConfig.banner.queueNameSize) data.screenConfig.banner.queueNameSize = defaultBanner.queueNameSize;
        if (!data.screenConfig.banner.badgeSize) data.screenConfig.banner.badgeSize = defaultBanner.badgeSize;
        if (!data.screenConfig.banner.instructionSize) data.screenConfig.banner.instructionSize = defaultBanner.instructionSize;
        if (!data.screenConfig.banner.height) data.screenConfig.banner.height = defaultBanner.height;
        if (!data.screenConfig.banner.borderRadius && data.screenConfig.banner.borderRadius !== 0) data.screenConfig.banner.borderRadius = defaultBanner.borderRadius;
        if (!data.screenConfig.banner.borderWidth && data.screenConfig.banner.borderWidth !== 0) data.screenConfig.banner.borderWidth = defaultBanner.borderWidth;
        if (!data.screenConfig.banner.shadowOpacity && data.screenConfig.banner.shadowOpacity !== 0) data.screenConfig.banner.shadowOpacity = defaultBanner.shadowOpacity;
        if (!data.screenConfig.banner.preset) data.screenConfig.banner.preset = defaultBanner.preset;

        console.log("[Config] ✅ Banner après fusion:", JSON.stringify(data.screenConfig.banner, null, 2));
      }

      screenConfig.value = data.screenConfig;

      // Migration : Ajouter display et targetResolution si manquants
      if (!screenConfig.value.display) {
        screenConfig.value.display = { orientation: 'horizontal' };
      }
      if (!screenConfig.value.targetResolution) {
        screenConfig.value.targetResolution = { width: 1920, height: 1080 };
      }

      console.log("[Config] ✅ Audio activé:", data.screenConfig.audio.enabled);
      console.log("[Config] ✅ Animations activées:", data.screenConfig.animations.enabled);
      console.log("[Config] ✅ Orientation:", screenConfig.value.display.orientation);
      console.log("[Config] ✅ Résolution:", `${screenConfig.value.targetResolution.width}×${screenConfig.value.targetResolution.height}`);

      // --- GESTION DE L'INTERVALLE (SÉCURISÉE POUR HEROKU) ---
      if (refreshInterval) clearInterval(refreshInterval);
      
      // On n'active l'intervalle que s'il est défini ET on le bride à 30s minimum
      // car le serveur pousse déjà les updates via "queue_updated"
      if (screenConfig.value.refreshInterval) {
        const msInterval = Math.max(screenConfig.value.refreshInterval, 30000); 
        console.log(`[Config] ⏱️ Refresh programmé toutes les ${msInterval / 1000}s`);
        
        refreshInterval = setInterval(() => {
          if (socket.value?.connected) {
            refreshTickets();
          }
        }, msInterval);
      }
    } 
    else if (!screenConfig.value) {
      // 3. Backup par défaut si vraiment rien n'est reçu
      console.warn("[Config] ⚠️ Aucune config reçue. Utilisation du backup par défaut.");
      screenConfig.value = {
        enabled: true,
        display: { orientation: 'horizontal' },
        targetResolution: { width: 1920, height: 1080 },
        layout: { type: 'single', gap: 20 },
        branding: {
          backgroundColor: '#0f172a',
          backgroundType: 'color',
          colors: { primary: '#3B82F6' },
          fonts: { primary: 'sans-serif' },
          logo: { show: false }
        },
        audio: {
          enabled: true,
          volume: 0.8,
          callSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
          recallSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
          useVoice: true,
          voiceLang: 'fr-FR'
        },
        animations: {
          enabled: true,
          ticketTransition: 'fade',
          transitionDuration: 500
        },
        zones: [{
          id: 'default',
          name: 'Zone Principale',
          content: {
            type: 'queue_display',
            ticketFilter: 'BOTH',
            queueIds: [],
            gridColumns: 2,
            maxTickets: 10,
            ticketDisplayInfo: {
              showNumber: true,
              showQueueName: true,
              showCounterName: true,
              showWaitTime: false
            },
            waitingTicketStyle: {
              fontFamily: 'sans-serif',
              fontSize: 24,
              color: '#1E293B',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              padding: 16,
              borderRadius: 12
            }
          },
          style: { backgroundColor: '#FFFFFF', padding: 20, borderRadius: 12, backgroundType: 'color' },
          textStyle: { color: '#1E293B' }
        }]
      };
    } else {
      console.log("[Config] ℹ️ Config déjà présente, pas de mise à jour nécessaire.");
    }
  });

  // --- MISES À JOUR EN TEMPS RÉEL ---

  socket.value.on("screen_config_update", (data) => {
    console.log("[Config] 🔄 Mise à jour de configuration en direct", data);
    
    const incomingConfig = data.config || data.screenConfig || data;

    if (incomingConfig && (incomingConfig.zones || incomingConfig.branding || incomingConfig.banner)) {
      const updatedConfig = {
        ...screenConfig.value,
        ...incomingConfig,
        branding: { ...(screenConfig.value?.branding || {}), ...(incomingConfig.branding || {}) },
        layout: { ...(screenConfig.value?.layout || {}), ...(incomingConfig.layout || {}) },
        banner: incomingConfig.banner ? {
          ...(screenConfig.value?.banner || {}),
          ...incomingConfig.banner,
          normal: { ...(screenConfig.value?.banner?.normal || {}), ...(incomingConfig.banner?.normal || {}) },
          recall: { ...(screenConfig.value?.banner?.recall || {}), ...(incomingConfig.banner?.recall || {}) },
          displayDuration: { ...(screenConfig.value?.banner?.displayDuration || {}), ...(incomingConfig.banner?.displayDuration || {}) }
        } : screenConfig.value?.banner
      };

      if (updatedConfig.zones && Array.isArray(updatedConfig.zones)) {
        updatedConfig.zones = updatedConfig.zones.map(zone => {
          if (zone.content?.type === 'queue_display') {
            if (!zone.content.ticketFilter) {
              zone.content.ticketFilter = 'BOTH';
            }
            if (!zone.content.gridColumns) {
              zone.content.gridColumns = 2;
            }
            if (!zone.content.maxTickets) {
              zone.content.maxTickets = 10;
            }
            if (!zone.content.calledTicketDisplayFormat) {
              zone.content.calledTicketDisplayFormat = 'block';
            }
            if (!zone.content.maxCalledTickets) {
              zone.content.maxCalledTickets = 5;
            }
            if (!zone.content.ticketDisplayInfo) {
              zone.content.ticketDisplayInfo = {
                showNumber: true,
                showQueueName: true,
                showCounterName: true,
                showWaitTime: false
              };
            }
            if (!zone.content.waitingTicketStyle) {
              zone.content.waitingTicketStyle = {
                fontFamily: zone.textStyle?.fontFamily || 'sans-serif',
                fontSize: 24,
                color: zone.textStyle?.color || '#FFFFFF',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                padding: 16,
                borderRadius: 12
              };
            }
            // ✅ Initialiser counterStyle si manquant
            if (!zone.content.counterStyle) {
              zone.content.counterStyle = {
                fontFamily: zone.textStyle?.fontFamily || 'Plus Jakarta Sans',
                fontSize: 38,
                fontWeight: '700',
                color: zone.textStyle?.color || '#FFFFFF',
                backgroundColor: 'transparent',
                padding: 12,
                borderRadius: 12,
                borderWidth: 2,
                borderColor: '#1e3a8a'
              };
            }
          }
          return zone;
        });
      }

      // Initialiser et compléter les paramètres audio
      const defaultAudio = {
        enabled: true,
        volume: 0.8,
        callSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
        recallSound: 'https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3',
        useVoice: true,
        voiceLang: 'fr-FR'
      };

      if (!updatedConfig.audio) {
        updatedConfig.audio = defaultAudio;
      } else {
        // Fusionner avec les valeurs par défaut pour compléter les propriétés manquantes
        updatedConfig.audio = {
          ...defaultAudio,
          ...updatedConfig.audio
        };
      }

      // S'assurer que audio est bien fusionné depuis incomingConfig
      if (incomingConfig.audio) {
        updatedConfig.audio = {
          ...updatedConfig.audio,
          ...incomingConfig.audio
        };
        console.log("[Config] 🔊 Audio mis à jour:", {
          enabled: updatedConfig.audio.enabled,
          useVoice: updatedConfig.audio.useVoice,
          voiceLang: updatedConfig.audio.voiceLang
        });
      }

      // Initialiser les paramètres d'animation si manquants
      if (!updatedConfig.animations) {
        updatedConfig.animations = {
          enabled: true,
          ticketTransition: 'fade',
          transitionDuration: 500
        };
      }

      // Initialiser les paramètres de la banner si manquants
      if (!updatedConfig.banner) {
        updatedConfig.banner = {
          normal: {
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: 'rgba(255, 255, 255, 0.2)',
            textColor: 'rgb(15, 23, 42)',
            iconColor: '#1e3a8a',
            iconBackgroundColor: 'rgb(239, 246, 255)',
            badgeColor: 'rgb(29, 78, 216)',
            badgeBorderColor: 'rgb(29, 78, 216)'
          },
          recall: {
            backgroundColor: 'rgb(15, 23, 42)',
            borderColor: 'rgba(245, 158, 11, 0.4)',
            textColor: 'rgb(251, 191, 36)',
            iconColor: '#f59e0b',
            iconBackgroundColor: 'rgba(245, 158, 11, 0.1)',
            badgeColor: 'rgb(245, 158, 11)',
            badgeBorderColor: 'rgb(245, 158, 11)',
            recallBadgeColor: 'rgb(245, 158, 11)'
          },
          borderRadius: 32,
          borderWidth: 1,
          shadowOpacity: 0.3,
          displayDuration: {
            normal: 5,
            recall: 7
          }
        };
      }

      screenConfig.value = updatedConfig;

      console.log("[Config] ✅ Banner après mise à jour en direct:", JSON.stringify(screenConfig.value.banner, null, 2));

      // Migration : Ajouter display et targetResolution si manquants
      if (!screenConfig.value.display) {
        screenConfig.value.display = { orientation: 'horizontal' };
      }
      if (!screenConfig.value.targetResolution) {
        screenConfig.value.targetResolution = { width: 1920, height: 1080 };
      }

      console.log("[Config] ✅ Configuration mise à jour - Audio:", updatedConfig.audio.enabled);
      
      if (refreshInterval) clearInterval(refreshInterval);
      if (screenConfig.value.refreshInterval) {
        refreshInterval = setInterval(() => refreshTickets(), screenConfig.value.refreshInterval);
      }
    }
  });

  // Événement d'appel de ticket
  socket.value.on("ticket_called", (data) => {
    const type = data.isRecall ? "🔔 RAPPEL" : "📢 NOUVEL APPEL";
    console.log(`[Socket] ${type} - Ticket: ${data.ticket?.number || data.number}`);
    handleTicketCalled(data);
  });

  socket.value.on("queue_updated", () => {
    console.log("[Socket] 🔄 File d'attente modifiée, rafraîchissement...");
    refreshTickets();
  });

  // ✅ Rafraîchissement de la visibilité des queues (nouveau jour)
  socket.value.on("queue_visibility_refresh", (data) => {
    console.log("[Socket] 📅 Nouveau jour détecté - Rafraîchissement de la visibilité des files", data);
    console.log(`[Socket] 📅 Jour actuel: ${data.currentDay} (${data.currentDayEn})`);

    // Recharger la configuration de l'écran (qui filtre les queues visibles)
    if (socket.value) {
      console.log("[Socket] 🔄 Demande de mise à jour de la configuration...");
      socket.value.emit("request_screen_config");
    }

    // Rafraîchir aussi les tickets
    refreshTickets();
  });

  // ✅ Écouter quand un ticket est terminé
  socket.value.on("ticket_finished", (data) => {
    console.log(`[Socket] ✅ Ticket terminé: ${data.ticket?.number}`);

    // Mettre à jour le ticket local immédiatement
    const ticketIndex = tickets.value.findIndex(t => t._id === data.ticket._id || t.number === data.ticket.number);
    if (ticketIndex !== -1) {
      tickets.value[ticketIndex].status = 'DONE';
      tickets.value[ticketIndex].finishedAt = data.ticket.finishedAt || new Date().toISOString();
      console.log(`[Tickets] ✅ Ticket ${data.ticket.number} marqué comme DONE localement`);
    }

    // Rafraîchir les tickets depuis le serveur après un court délai
    setTimeout(() => refreshTickets(), 500);
  });

  socket.value.on("new_ticket_waiting", (data) => {
    console.log("[Socket] 🎫 Nouveau ticket créé:", data.ticket.number);
    refreshTickets();
  });

  socket.value.on("queue_empty", () => {
    console.log("[Socket] ⚠️ Plus de tickets en attente");
  });

  socket.value.on("tickets_reset", () => {
    console.log("[Socket] 🔄 Tous les tickets ont été réinitialisés pour cette agence");
    // Vider tous les tickets affichés
    tickets.value = [];
    refreshTickets();
  });
};

const playBell = async (ticketNumber = null, counterName = null) => {
  // Vérifier si l'audio est activé dans la config
  if (!screenConfig.value?.audio?.enabled) {
    console.log("[Audio] 🔇 Audio désactivé dans la configuration");
    return;
  }

  console.log("[Audio] 🔔 Tentative de lecture du son");
  const audio = bellSound.value;

  if (!audio) {
    console.error("[Audio] ❌ Élément audio introuvable");
    if (screenConfig.value?.audio?.useVoice) {
      speakTicket(ticketNumber, counterName, false);
    }
    return;
  }

  // Mettre à jour la source audio si personnalisée
  const customSound = screenConfig.value?.audio?.callSound;
  if (customSound && customSound !== audio.src) {
    console.log("[Audio] 🎵 Utilisation du son personnalisé:", customSound);
    audio.src = customSound;
    audio.load();
  }

  console.log("[Audio] 📊 État avant lecture:", {
    unlocked: window.__AUDIO_UNLOCKED__,
    paused: audio.paused,
    readyState: audio.readyState,
    volume: audio.volume
  });

  // Si l'audio n'est pas débloqué, essayer de le faire automatiquement
  if (!window.__AUDIO_UNLOCKED__) {
    console.warn("[Audio] ⚠️ Audio non unlock, tentative automatique...");
    const unlocked = await enableAudio();
    if (!unlocked) {
      console.warn("[Audio] ❌ Échec unlock, fallback voix");
      if (screenConfig.value?.audio?.useVoice) {
        speakTicket(ticketNumber, counterName, false);
      }
      return;
    }
  }

  try {
    audio.currentTime = 0;
    audio.volume = screenConfig.value?.audio?.volume ?? 0.8;
    audio.muted = false;

    const playPromise = audio.play();

    if (playPromise !== undefined) {
      await playPromise;
      console.log("[Audio] ✅ Son joué avec succès");
    }

    // Jouer la synthèse vocale en plus du son si activée
    // Ajouter un petit délai pour éviter les conflits avec le son
    if (screenConfig.value?.audio?.useVoice) {
      setTimeout(() => {
        speakTicket(ticketNumber, counterName, false);
      }, 300); // Délai de 300ms après le début du BIP
    }
  } catch (err) {
    console.error("[Audio] ❌ Erreur lecture:", err.name, err.message);
    if (screenConfig.value?.audio?.useVoice) {
      speakTicket(ticketNumber, counterName, false); // Fallback vers synthèse vocale
    }
  }
};

const playRecallBell = async (ticketNumber = null, counterName = null) => {
  // Vérifier si l'audio est activé dans la config
  if (!screenConfig.value?.audio?.enabled) {
    console.log("[Audio] 🔇 Audio désactivé dans la configuration");
    return;
  }

  console.log("[Audio] 🔔🔔 Tentative de lecture du son de rappel (x2)");
  const audio = bellSound.value;

  if (!audio) {
    console.error("[Audio] ❌ Élément audio introuvable");
    if (screenConfig.value?.audio?.useVoice) {
      speakTicket(ticketNumber, counterName, true);
    }
    return;
  }

  // Mettre à jour la source audio si personnalisée
  const customSound = screenConfig.value?.audio?.recallSound;
  if (customSound && customSound !== audio.src) {
    console.log("[Audio] 🎵 Utilisation du son de rappel personnalisé:", customSound);
    audio.src = customSound;
    audio.load();
  }

  // Si l'audio n'est pas débloqué, essayer de le faire automatiquement
  if (!window.__AUDIO_UNLOCKED__) {
    console.warn("[Audio] ⚠️ Audio non unlock, tentative automatique...");
    const unlocked = await enableAudio();
    if (!unlocked) {
      console.warn("[Audio] ❌ Échec unlock, fallback voix");
      speakTicket(ticketNumber, counterName, true);
      return;
    }
  }

  try {
    // Premier son
    audio.currentTime = 0;
    audio.volume = screenConfig.value?.audio?.volume ?? 0.8;
    audio.muted = false;

    const playPromise1 = audio.play();
    if (playPromise1 !== undefined) {
      await playPromise1;
      console.log("[Audio] ✅ Premier son de rappel joué");
    }

    // Jouer la synthèse vocale en plus du son si activée
    // Ajouter un délai pour éviter les conflits avec le son
    if (screenConfig.value?.audio?.useVoice) {
      setTimeout(() => {
        speakTicket(ticketNumber, counterName, true);
      }, 300); // Délai de 300ms après le début du premier BIP
    }

    // Deuxième son après 400ms
    setTimeout(async () => {
      try {
        audio.currentTime = 0;
        const playPromise2 = audio.play();
        if (playPromise2 !== undefined) {
          await playPromise2;
          console.log("[Audio] ✅ Deuxième son de rappel joué");
        }
      } catch (err) {
        console.error("[Audio] ❌ Erreur 2ème son:", err.message);
      }
    }, 400);
  } catch (err) {
    console.error("[Audio] ❌ Erreur lecture rappel:", err.name, err.message);
    if (screenConfig.value?.audio?.useVoice) {
      speakTicket(ticketNumber, counterName, true); // Fallback vers synthèse vocale
    }
  }
};

const speakTicket = async (ticketNumber = null, counterName = null, isRecall = false) => {
  // Vérifier si la synthèse vocale est activée
  if (!screenConfig.value?.audio?.useVoice) {
    console.log("[Voice] 🔇 Synthèse vocale désactivée dans la configuration");
    return;
  }

  console.log("[Voice] 🗣️ Utilisation de la synthèse vocale");

  if (!('speechSynthesis' in window)) {
    console.error("[Voice] ❌ speechSynthesis n'est pas disponible dans ce navigateur");
    return;
  }

  // 🔥 Vérifier si la synthèse vocale est débloquée
  if (!window.__SPEECH_UNLOCKED__ && !speechEnabled.value) {
    console.warn("[Voice] ⚠️ Synthèse vocale non débloquée, tentative de déblocage...");
    const unlocked = await enableSpeechSynthesis();
    if (!unlocked) {
      console.error("[Voice] ❌ Impossible de débloquer la synthèse vocale");
      // On continue quand même, certains navigateurs peuvent fonctionner sans déblocage explicite
    }
  }

  try {
    // Annuler toute synthèse en cours
    speechSynthesis.cancel();

    // Construire le message selon la langue
    const lang = screenConfig.value?.audio?.voiceLang || "fr-FR";
    let message = "";

      if (ticketNumber && counterName) {
        // Messages personnalisés selon la langue
        switch (lang) {
          case 'fr-FR':
            message = isRecall
              ? `Rappel du ticket ${ticketNumber} au guichet ${counterName}`
              : `Ticket ${ticketNumber} au guichet ${counterName}`;
            break;
          case 'en-US':
          case 'en-GB':
            message = isRecall
              ? `Recall of ticket ${ticketNumber} at counter ${counterName}`
              : `Ticket ${ticketNumber} at counter ${counterName}`;
            break;
          case 'es-ES':
            message = isRecall
              ? `Recordatorio del ticket ${ticketNumber} en el mostrador ${counterName}`
              : `Ticket ${ticketNumber} en el mostrador ${counterName}`;
            break;
          case 'de-DE':
            message = isRecall
              ? `Wiederholung des Tickets ${ticketNumber} am Schalter ${counterName}`
              : `Ticket ${ticketNumber} am Schalter ${counterName}`;
            break;
          case 'it-IT':
            message = isRecall
              ? `Richiamo del ticket ${ticketNumber} allo sportello ${counterName}`
              : `Ticket ${ticketNumber} allo sportello ${counterName}`;
            break;
          case 'ar-SA':
            message = isRecall
              ? `تذكير بالتذكرة ${ticketNumber} في الشباك ${counterName}`
              : `التذكرة ${ticketNumber} في الشباك ${counterName}`;
            break;
          default:
            message = isRecall
              ? `Ticket ${ticketNumber}, counter ${counterName}`
              : `Ticket ${ticketNumber}, counter ${counterName}`;
        }
      } else {
        // Message générique si pas d'infos
        message = isRecall ? "Rappel de ticket" : "Nouveau ticket appelé";
      }

    // Fonction pour lancer la synthèse une fois les voix chargées
    const speakMessage = () => {
      const voices = speechSynthesis.getVoices();
      console.log(`[Voice] 📋 ${voices.length} voix disponibles`);

      // Chercher une voix compatible avec la langue
      let selectedVoice = voices.find(voice => voice.lang === lang);

      // Fallback: chercher une voix qui commence par le code langue (ex: fr pour fr-FR)
      if (!selectedVoice) {
        const langCode = lang.split('-')[0];
        selectedVoice = voices.find(voice => voice.lang.startsWith(langCode));
      }

      // Fallback ultime: prendre la première voix disponible
      if (!selectedVoice && voices.length > 0) {
        selectedVoice = voices[0];
      }

      if (selectedVoice) {
        console.log(`[Voice] 🎤 Voix sélectionnée: ${selectedVoice.name} (${selectedVoice.lang})`);
      } else {
        console.warn(`[Voice] ⚠️ Aucune voix trouvée pour ${lang}, utilisation voix par défaut`);
      }

      const msg = new SpeechSynthesisUtterance(message);
      msg.lang = lang;
      if (selectedVoice) {
        msg.voice = selectedVoice;
      }
      msg.rate = 1.0;
      msg.pitch = 1.0;
      msg.volume = screenConfig.value?.audio?.volume ?? 1.0;

      msg.onstart = () => console.log("[Voice] ▶️ Synthèse vocale démarrée:", message);
      msg.onend = () => console.log("[Voice] ✅ Synthèse vocale terminée");
      msg.onerror = (err) => {
        console.error("[Voice] ❌ Erreur synthèse:", err);
        console.error("[Voice] ❌ Détails:", {
          error: err.error,
          charIndex: err.charIndex,
          elapsedTime: err.elapsedTime
        });
      };

      speechSynthesis.speak(msg);
      console.log("[Voice] ✅ Message vocal envoyé:", message);
    };

    // Vérifier si les voix sont déjà chargées
    const voices = speechSynthesis.getVoices();
    if (voices.length > 0) {
      // Voix déjà disponibles, lancer immédiatement
      speakMessage();
    } else {
      // Attendre que les voix soient chargées
      console.log("[Voice] ⏳ Attente du chargement des voix...");

      const handleVoicesChanged = () => {
        console.log("[Voice] ✅ Voix chargées");
        speechSynthesis.removeEventListener('voiceschanged', handleVoicesChanged);
        speakMessage();
      };

      speechSynthesis.addEventListener('voiceschanged', handleVoicesChanged);

      // Timeout de sécurité de 2 secondes
      setTimeout(() => {
        speechSynthesis.removeEventListener('voiceschanged', handleVoicesChanged);
        console.log("[Voice] ⏰ Timeout - lancement sans attendre les voix");
        speakMessage();
      }, 2000);
    }
  } catch (err) {
    console.error("[Voice] ❌ Erreur lors de la synthèse vocale:", err);
  }
};


const handleTicketCalled = (data) => {
  const ticket = data.ticket || data;
  const counter = data.counterName || "Guichet";
  const isRecallEvent = data.isRecall || false;

  console.log(`
╔════════════════════════════════════════════════════════════════╗
║ ${isRecallEvent ? '🔔 RAPPEL DE TICKET' : '📢 NOUVEL APPEL'}                                      ║
╠════════════════════════════════════════════════════════════════╣
║ Ticket:  ${ticket.number?.padEnd(20) || 'N/A'}                          ║
║ Guichet: ${counter?.padEnd(20) || 'N/A'}                          ║
║ Type:    ${isRecallEvent ? 'RAPPEL (recall_ticket)' : 'NOUVEAU (call_next)'}         ║
╚════════════════════════════════════════════════════════════════╝
  `);

  // DEBUG: Vérifier la présence de l'icône
  console.log("[DEBUG] Ticket appelé - queueId:", {
    hasQueueId: !!ticket.queueId,
    queueName: ticket.queueId?.name,
    hasIcon: !!ticket.queueId?.icon,
    iconValue: ticket.queueId?.icon
  });

  // Validation : vérifier que les données sont complètes
  if (!ticket || !ticket.number) {
    console.error("[Ticket Called] ⚠️ Données de ticket invalides:", data);
    return;
  }

  // Mettre à jour le flag de rappel
  isRecall.value = isRecallEvent;

  // ✅ Activer le clignotement pour TOUS les appels (premier appel ET rappel)
  blinkingTicketId.value = ticket._id;
  blinkingTicketType.value = isRecallEvent ? 'recall' : 'normal';
  console.log(`[Blinking] 💡 Clignotement activé (${blinkingTicketType.value}) pour le ticket ${ticket.number} (ID: ${ticket._id})`);

  // Désactiver le clignotement après 7 secondes
  setTimeout(() => {
    blinkingTicketId.value = null;
    blinkingTicketType.value = null;
    console.log(`[Blinking] ⏹️ Clignotement désactivé`);
  }, 7000);

  // Play audio notification (différent pour les rappels)
  if (isRecallEvent) {
    playRecallBell(ticket.number, counter);
  } else {
    playBell(ticket.number, counter);
  }

  callingTicket.value = { ...ticket, counterName: counter };

  // DEBUG: Vérifier le contenu de callingTicket
  console.log("[DEBUG] callingTicket défini:", {
    number: callingTicket.value.number,
    hasQueueId: !!callingTicket.value.queueId,
    queueName: callingTicket.value.queueId?.name,
    hasIcon: !!callingTicket.value.queueId?.icon,
    iconValue: callingTicket.value.queueId?.icon,
    fullQueueId: callingTicket.value.queueId
  });

  // Mise à jour locale immédiate du ticket dans la liste
  const ticketIndex = tickets.value.findIndex(t => t._id === ticket._id || t.number === ticket.number);
  if (ticketIndex !== -1) {
    // Le ticket existe, le mettre à jour
    tickets.value[ticketIndex] = {
      ...tickets.value[ticketIndex],
      ...ticket,
      status: 'CALLED',
      counterName: counter,
      updatedAt: new Date().toISOString()
    };
    console.log(`[Ticket Called] ✅ Ticket ${ticket.number} mis à jour localement (index: ${ticketIndex})`);
  } else {
    // Le ticket n'existe pas dans la liste, l'ajouter
    tickets.value.push({
      ...ticket,
      status: 'CALLED',
      counterName: counter,
      updatedAt: new Date().toISOString()
    });
    console.log(`[Ticket Called] ✅ Ticket ${ticket.number} ajouté à la liste locale`);
  }

  // Update tickets list from server (pour synchroniser avec le backend)
  // Délai de 800ms pour laisser le temps au serveur de traiter le changement
  setTimeout(() => {
    console.log(`[Ticket Called] 🔄 Rafraîchissement des tickets depuis le serveur...`);
    refreshTickets();
  }, 800);

  // Clear calling ticket after delay (utiliser la durée de la config si disponible, sinon valeurs par défaut)
  const defaultDelay = isRecallEvent ? 7000 : 5000;
  const configDelay = screenConfig.value?.banner?.displayDuration
    ? (isRecallEvent
        ? screenConfig.value.banner.displayDuration.recall * 1000
        : screenConfig.value.banner.displayDuration.normal * 1000)
    : defaultDelay;

  setTimeout(() => {
    callingTicket.value = null;
    isRecall.value = false;
  }, configDelay);
};




// Demander la configuration au serveur via WebSocket (pas de fetch HTTP)
const requestScreenConfig = () => {
  if (socket.value && socket.value.connected) {
    console.log("[Config] 📡 Demande de configuration screen via WebSocket...");
    socket.value.emit("request_screen_config");
  } else {
    console.warn("[Config] ⚠️ WebSocket non connecté, impossible de demander la config");
  }
};

const refreshTickets = () => {
  // Ajout d'une sécurité pour ne pas spammer si le socket est déconnecté
  if (socket.value && socket.value.connected) {
    socket.value.emit("request_tickets_refresh"); 
  }
};

onMounted(() => {
  console.log("[Screen] 🚀 Composant monté");

  // Vérifier l'élément audio
  setTimeout(() => {
    const audio = bellSound.value;
    if (audio) {
      console.log("[Audio] 📊 Élément audio détecté:", {
        src: audio.src || audio.currentSrc,
        readyState: audio.readyState,
        networkState: audio.networkState
      });

      // Forcer le préchargement
      audio.load();

      // Écouter les événements de chargement
      audio.addEventListener('loadeddata', () => {
        console.log("[Audio] ✅ Audio préchargé avec succès");
      });

      audio.addEventListener('error', (e) => {
        console.error("[Audio] ❌ Erreur de chargement:", e);
        // Essayer la source de fallback
        if (audio.src.includes('mixkit')) {
          console.log("[Audio] 🔄 Tentative avec source de secours...");
          audio.src = 'https://cdn.freesound.org/previews/320/320655_5260872-lq.mp3';
          audio.load();
        }
      });
    } else {
      console.error("[Audio] ❌ Élément audio non trouvé!");
    }
  }, 100);

  checkToken(); // Initialise le WebSocket qui enverra automatiquement la config via screen_init

  // Écouter le redimensionnement de la fenêtre pour adapter l'affichage
  const handleResize = () => {
    windowSize.value = { width: window.innerWidth, height: window.innerHeight };
  };
  window.addEventListener('resize', handleResize);

  // Débloquer l'audio sur TOUTE interaction utilisateur (multiples écouteurs)
  const unlockEvents = ['click', 'touchstart', 'touchend', 'keydown', 'mousedown'];

  const attemptUnlock = async () => {
    if (!window.__AUDIO_UNLOCKED__) {
      console.log("[Audio] 🎯 Tentative de déblocage via interaction");
      await enableAudio();
    }
  };

  unlockEvents.forEach(eventType => {
    document.addEventListener(eventType, attemptUnlock, { once: true, passive: true });
  });

  // Tentative de déblocage automatique après 2 secondes (pour Xibo)
  // Cela peut échouer sans interaction utilisateur, mais on essaye quand même
  setTimeout(async () => {
    if (!window.__AUDIO_UNLOCKED__) {
      console.log("[Audio] 🤖 Tentative de déblocage automatique...");
      await enableAudio().catch(() => {
        console.log("[Audio] ⚠️ Déblocage automatique échoué (attendu sans interaction)");
      });
    }
  }, 2000);
});

onUnmounted(() => {
  if (socket.value) {
    socket.value.off(); // Nettoie tous les écouteurs avant de déconnecter
    socket.value.disconnect();
  }
  if (clockInterval) clearInterval(clockInterval);
  window.removeEventListener('resize', () => {
    windowSize.value = { width: window.innerWidth, height: window.innerHeight };
  });
  if (refreshInterval) clearInterval(refreshInterval);
});
</script>

<style scoped>
/* ========================================
   RESETS ET SUPPRESSION DES SCROLLBARS
   ======================================== */

/* Force le calcul des tailles incluant padding/border */
* {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

/* Supprime radicalement les barres de défilement (Xibo/Chrome/Safari) */
:global(html), :global(body) {
  margin: 0 !important;
  padding: 0 !important;
  height: 100vh !important;
  width: 100vw !important;
  overflow: hidden !important;
  position: fixed; /* Bloque tout mouvement de scroll élastique */
}

/* Masque les scrollbars pour tous les navigateurs */
::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* Conteneur principal */
.screen-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
}

/* ========================================
   ANIMATIONS (COMPATIBILITÉ XIBO)
   ======================================== */

/* Animation pour nouveau ticket */
.pop-enter-active {
  -webkit-animation: pop-in 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: pop-in 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@-webkit-keyframes pop-in {
  0% { -webkit-transform: scale(0.5) translateY(50px); opacity: 0; }
  100% { -webkit-transform: scale(1) translateY(0); opacity: 1; }
}

@keyframes pop-in {
  0% { transform: scale(0.5) translateY(50px); opacity: 0; }
  100% { transform: scale(1) translateY(0); opacity: 1; }
}

/* Animation pour rappel */
.bounce-enter-active {
  -webkit-animation: bounce-in 0.6s ease-out;
  animation: bounce-in 0.6s ease-out;
}

@-webkit-keyframes bounce-in {
  0% { -webkit-transform: scale(0.3) rotate(-5deg); opacity: 0; }
  50% { -webkit-transform: scale(1.1) rotate(2deg); }
  70% { -webkit-transform: scale(0.95) rotate(-1deg); }
  100% { -webkit-transform: scale(1) rotate(0deg); opacity: 1; }
}

@keyframes bounce-in {
  0% { transform: scale(0.3) rotate(-5deg); opacity: 0; }
  50% { transform: scale(1.1) rotate(2deg); }
  70% { transform: scale(0.95) rotate(-1deg); }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
}

/* Pulse spécial pour les rappels */
.recall-pulse {
  -webkit-animation: recall-pulse-animation 1.5s ease-in-out infinite;
  animation: recall-pulse-animation 1.5s ease-in-out infinite;
}

@-webkit-keyframes recall-pulse-animation {
  0%, 100% {
    -webkit-box-shadow: 0 0 20px rgba(245, 158, 11, 0.4);
    -webkit-transform: scale(1);
  }
  50% {
    -webkit-box-shadow: 0 0 40px rgba(245, 158, 11, 0.8);
    -webkit-transform: scale(1.02);
  }
}

@keyframes recall-pulse-animation {
  0%, 100% {
    box-shadow: 0 0 20px rgba(245, 158, 11, 0.4);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 40px rgba(245, 158, 11, 0.8);
    transform: scale(1.02);
  }
}

.calling-ticket-animation {
  box-shadow: 0 10px 50px rgba(0, 0, 0, 0.3);
}

/* ✅ Animation de clignotement pour le PREMIER APPEL (7 secondes - BLEU) */
.blinking-ticket-normal {
  -webkit-animation: blink-animation-normal 0.8s ease-in-out infinite;
  animation: blink-animation-normal 0.8s ease-in-out infinite;
  animation-duration: 0.8s;
}

@-webkit-keyframes blink-animation-normal {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
    background-color: rgba(59, 130, 246, 0.3) !important; /* Bleu */
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.03);
    background-color: rgba(59, 130, 246, 0.7) !important; /* Bleu intense */
  }
}

@keyframes blink-animation-normal {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
    background-color: rgba(59, 130, 246, 0.3) !important; /* Bleu */
  }
  50% {
    opacity: 0.5;
    transform: scale(1.03);
    background-color: rgba(59, 130, 246, 0.7) !important; /* Bleu intense */
  }
}

/* ✅ Animation de clignotement pour le RAPPEL (7 secondes - ORANGE) */
.blinking-ticket-recall {
  -webkit-animation: blink-animation-recall 0.8s ease-in-out infinite;
  animation: blink-animation-recall 0.8s ease-in-out infinite;
  animation-duration: 0.8s;
}

@-webkit-keyframes blink-animation-recall {
  0%, 100% {
    opacity: 1;
    -webkit-transform: scale(1);
    background-color: rgba(245, 158, 11, 0.3) !important; /* Orange */
  }
  50% {
    opacity: 0.5;
    -webkit-transform: scale(1.03);
    background-color: rgba(245, 158, 11, 0.7) !important; /* Orange intense */
  }
}

@keyframes blink-animation-recall {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
    background-color: rgba(245, 158, 11, 0.3) !important; /* Orange */
  }
  50% {
    opacity: 0.5;
    transform: scale(1.03);
    background-color: rgba(245, 158, 11, 0.7) !important; /* Orange intense */
  }
}

.audio-unlock-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.7); /* Fond sombre semi-transparent */
  backdrop-filter: blur(8px); /* Effet de flou premium */
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.audio-unlock-btn {
  background: #6366f1; /* Indigo Premium */
  color: white;
  border: none;
  padding: 20px 40px;
  border-radius: 50px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(99, 102, 241, 0.4);
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s ease;
}

.audio-unlock-btn:active {
  transform: scale(0.95);
}

.audio-unlock-btn .icon {
  font-size: 24px;
}

/* ========================================
   OVERLAY FULLSCREEN POUR TICKET APPELÉ
   ======================================== */

.ticket-call-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; /* Au-dessus de TOUT */
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.97) 0%, rgba(30, 41, 59, 0.95) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.ticket-call-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  text-align: center;
  padding: 60px;
  max-width: 90vw;
  position: relative;
}

/* Animation pour nouvel appel */
.call-animation {
  animation: pulse-glow 2s ease-in-out infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    transform: scale(1);
    filter: drop-shadow(0 0 30px rgba(59, 130, 246, 0.4));
  }
  50% {
    transform: scale(1.02);
    filter: drop-shadow(0 0 60px rgba(59, 130, 246, 0.7));
  }
}

/* Animation pour rappel */
.recall-animation {
  animation: shake-glow 0.8s ease-in-out infinite;
}

@keyframes shake-glow {
  0%, 100% {
    transform: translateX(0) scale(1);
    filter: drop-shadow(0 0 30px rgba(245, 158, 11, 0.4));
  }
  25% {
    transform: translateX(-10px) scale(1.01);
    filter: drop-shadow(0 0 50px rgba(245, 158, 11, 0.6));
  }
  75% {
    transform: translateX(10px) scale(1.01);
    filter: drop-shadow(0 0 50px rgba(245, 158, 11, 0.6));
  }
}

/* Badge Rappel */
.recall-badge {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(245, 158, 11, 0.2);
  border: 3px solid rgba(245, 158, 11, 0.8);
  padding: 20px 40px;
  border-radius: 20px;
  font-size: 36px;
  font-weight: 900;
  color: #F59E0B;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  animation: blink 1s ease-in-out infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Numéro du Ticket */
.ticket-number-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.ticket-number {
  font-size: 200px; /* ÉNORME */
  font-weight: 900;
  line-height: 1;
  margin: 0;
  text-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.05em;
}

/* Service */
.ticket-service {
  font-size: 42px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Flèche */
.arrow-down {
  color: rgba(255, 255, 255, 0.6);
  animation: bounce-arrow 1.5s ease-in-out infinite;
}

@keyframes bounce-arrow {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(20px); }
}

/* Badge Caisse */
.counter-badge {
  font-size: 64px;
  font-weight: 900;
  padding: 30px 80px;
  border-radius: 30px;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  border: 4px solid rgba(255, 255, 255, 0.3);
}

/* Texte d'instruction */
.instruction-text {
  font-size: 28px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 20px;
}

/* Transitions pour l'overlay */
.overlay-pop-enter-active {
  animation: overlay-zoom-in 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.overlay-pop-leave-active {
  animation: overlay-zoom-out 0.4s ease-in-out;
}

@keyframes overlay-zoom-in {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes overlay-zoom-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

/* --- Animation d'Appel Standard (Élégante & Fluide) --- */
.overlay-fade-enter-active {
  animation: ticket-entry 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.overlay-fade-leave-active {
  transition: all 0.4s ease-in;
}

.overlay-fade-leave-to {
  opacity: 0;
  transform: scale(0.9);
  filter: blur(10px);
}

@keyframes ticket-entry {
  0% {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* --- Animation de Rappel (Alerte Professionnelle) --- */
.overlay-bounce-enter-active {
  animation: recall-entry 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes recall-entry {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  40% {
    transform: scale(1.05);
  }
  55% {
    transform: scale(1);
  }
  /* Petit "shake" horizontal pour simuler la cloche */
  65% { transform: translateX(-4px); }
  75% { transform: translateX(4px); }
  85% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}

/* Responsive pour petits écrans */
@media (max-width: 768px) {
  .ticket-number {
    font-size: 120px;
  }
  .counter-badge {
    font-size: 48px;
    padding: 20px 50px;
  }
  .ticket-service {
    font-size: 32px;
  }
}

/* Banner Slide Container - Conversion de Tailwind vers CSS pur */
.banner-slide-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  padding: 16px;
  display: flex;
  justify-content: center;
}

.banner-slide-content {
  position: relative;
  width: 100%;
  max-width: 98%;
  min-height: 12rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 32px;
  border-style: solid;
  transition: all 0.5s ease;
  gap: 16px;
  box-sizing: border-box;
  /* borderRadius et borderWidth sont maintenant appliqués via :style */
}

.banner-left-section {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 1;
  min-width: 0;
}

.banner-icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 16px;
  flex-shrink: 0;
}

.banner-ticket-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex-shrink: 1;
}

.banner-queue-name {
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* font-size et font-family appliqués via :style */
}

.banner-ticket-number {
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.02em;
  white-space: nowrap;
  overflow: visible;
  margin: 0;
  /* font-size et font-family appliqués via :style */
}

.banner-right-section {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 1;
  min-width: 0;
}

.banner-counter-badge {
  padding: 12px 24px;
  border-radius: 12px;
  border-width: 2px;
  border-style: solid;
  white-space: nowrap;
}

.banner-counter-name {
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  /* font-size et font-family appliqués via :style */
}

.banner-instruction {
  margin-top: 8px;
  font-weight: 500;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  opacity: 0.6;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* font-size et font-family appliqués via :style */
}

.banner-recall-badge {
  position: absolute;
  top: 0;
  right: 24px;
  padding: 6px 16px;
  border-radius: 0 0 12px 12px;
  background-color: rgb(245 158 11);
  color: rgb(15 23 42);
  font-size: clamp(10px, 1vw, 14px);
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

/* Responsive pour très petits écrans */
@media (max-width: 768px) {
  .banner-slide-container {
    padding: 8px;
  }

  .banner-slide-content {
    padding: 12px 16px;
    border-radius: 20px;
    min-height: 8rem;
    flex-direction: column;
    gap: 12px;
  }

  .banner-left-section {
    width: 100%;
    justify-content: center;
    gap: 16px;
  }

  .banner-icon-container {
    padding: 12px;
  }

  .banner-ticket-info {
    align-items: center;
    text-align: center;
  }

  .banner-right-section {
    width: 100%;
    align-items: center;
    text-align: center;
  }

  .banner-counter-badge {
    padding: 8px 16px;
  }

  .banner-recall-badge {
    right: 12px;
  }
}

/* Transitions pour le volet qui descend */
.banner-slide-enter-active,
.banner-slide-leave-active {
  transition: all 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.banner-slide-enter-from,
.banner-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
</style>
